import React from 'react';
import { REPORT_KEYS } from '../../services/reportsApi';

export default function ReportFilters({
  reportKey,
  from,
  to,
  vehicleId,
  vehicles,
  loading,
  exporting,
  rangeInverted,
  onChangeReportKey,
  onChangeFrom,
  onChangeTo,
  onChangeVehicleId,
  onGenerate,
  onExport,
}) {
  const activeReport = REPORT_KEYS.find((r) => r.key === reportKey);
  const needsVehicle = Boolean(activeReport?.needsVehicle);
  const optionalVehicle = Boolean(activeReport?.optionalVehicle);
  const showVehicle = needsVehicle || optionalVehicle;
  const missingVehicle = needsVehicle && !vehicleId;
  const missingField = !reportKey || !from || !to || missingVehicle;
  const disableActions = missingField || rangeInverted;
  const busy = loading || exporting;

  const sortedVehicles = [...(vehicles || [])].sort((a, b) =>
    (a.name || '').localeCompare(b.name || '')
  );

  return (
    <div className="card" style={{ marginBottom: 24 }}>
      <div className="card-title">Report Filters</div>

      <div className="form-grid cols3" style={{ marginBottom: 12 }}>
        <div className="form-group">
          <label>Report Type</label>
          <select
            value={reportKey}
            onChange={(e) => onChangeReportKey(e.target.value)}
            disabled={busy}
          >
            <option value="">Select a report…</option>
            {REPORT_KEYS.map((r) => (
              <option key={r.key} value={r.key}>
                {r.label} ({r.requirement})
              </option>
            ))}
          </select>
        </div>

        {showVehicle && (
          <div className="form-group">
            <label>{needsVehicle ? 'Vehicle' : 'Vehicle (optional)'}</label>
            <select
              value={vehicleId}
              onChange={(e) => onChangeVehicleId(e.target.value)}
              disabled={busy}
            >
              <option value="">
                {needsVehicle ? 'Select a vehicle…' : 'All vehicles'}
              </option>
              {sortedVehicles.map((v) => (
                <option key={v._id} value={v._id}>
                  {v.name}{v.plate ? ` (${v.plate})` : ''}
                </option>
              ))}
            </select>
          </div>
        )}

        <div className="form-group">
          <label>From</label>
          <input
            type="date"
            value={from}
            onChange={(e) => onChangeFrom(e.target.value)}
            disabled={busy}
            max={to || undefined}
          />
        </div>

        <div className="form-group">
          <label>To</label>
          <input
            type="date"
            value={to}
            onChange={(e) => onChangeTo(e.target.value)}
            disabled={busy}
            min={from || undefined}
          />
        </div>
      </div>

      <div style={{ display: 'flex', gap: 8 }}>
        <button
          type="button"
          className="btn btn-primary btn-sm"
          onClick={onGenerate}
          disabled={disableActions || loading}
          aria-busy={loading ? 'true' : 'false'}
        >
          {loading ? 'Generating…' : 'Generate Report'}
        </button>
        <button
          type="button"
          className="btn btn-sm"
          onClick={onExport}
          disabled={disableActions || exporting}
          aria-busy={exporting ? 'true' : 'false'}
        >
          {exporting ? 'Exporting…' : 'Export PDF'}
        </button>
      </div>

      {rangeInverted && (
        <p className="text-sm danger" style={{ marginTop: 10 }}>
          "From" date must be on or before "To" date.
        </p>
      )}

      {!rangeInverted && missingField && (
        <p className="text-muted text-sm" style={{ marginTop: 10 }}>
          {needsVehicle
            ? 'Pick a report type, vehicle, and date range to enable generate and export.'
            : 'Pick a report type and a date range to enable generate and export.'}
        </p>
      )}
    </div>
  );
}
